let $ = jQuery.noConflict(),
	devMode,
	body,
	firstLoad = false,
	mobileCheck = false,
	currentY,
	pageTransition,
	barbaInitialized,
	resizeCallbacks = [],
	mobileResizeCallbacks = [],
	barbaCallbacks = [];

$(function () {
	initStarterKit();

	// Composants Mobile & Desktop
	new AnimationTitles();
	new Grid();
	new Menu();
	new ViewportHalfScrolled();
	new Sliders();

	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	} else {
		// Composants Desktop uniquement
	}
});

function initStarterKit() {
	body = $('body');
	mcubeDebug();
	mobileCheck = new MobileCheck();
	new ResizeEvents();
	pageTransition = new CustomPageTransition();
	new BasePageTransition();
	new AppearOnScroll();
	new DataLink();
	new Forms();
	new GDPR();
	new InitMatchHeight();
	new MadeByMcube();
	new Ressources();
}

function scrollListener(newY) {

}
